import React, { Component } from "react";
import PropTypes from "prop-types";
import { InsightContent, InsightTitle } from "../styles/main";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { livemonitorSelector, globalStateSelector } from "store/selector";
import LiveAgentState from "./LiveAgentState";
import LiveCallState from "./LiveCallState";
import colors from "../styles/colors";
import LiveChatState from "./LiveChatState";
const uuid = require("uuid");
export class LiveMonitorChatData extends Component {
  constructor(props) {
    super(props);
  }
  renderTitle(title) {
    const { __ } = this.context;
    return (
      <InsightTitle style={{ paddingTop: "0px", margin: "0px" }}>
        {__(title)}
      </InsightTitle>
    );
  }
  render() {
    return (
      <div style={{ width: "100%" }}>
        <InsightContent className="w-100" style={{ padding: "0px 10px" }}>
          <Row
            className="w-100"
            style={{ overflowY: "auto", height: "calc(100vh - 325px)" }}
          >
            <Col
              className="w-100"
              md={12}
              sm={12}
              lg={12}
              key={Math.random()}
              style={{ padding: "0px" }}
            >
              <LiveChatState list={this.props.liveChatData.totalStatus} />
            </Col>
          </Row>
        </InsightContent>
      </div>
    );
  }
}
LiveMonitorChatData.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  liveChatData: livemonitorSelector.getLiveChatData(state, { key: "liveChatData" }),
});

const dispatchToProps = (dispatch) => ({});
export default connect(stateToProps, dispatchToProps)(LiveMonitorChatData);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/LiveMonitorChatData.js